import { createStore } from "redux";
import { combineReducers } from "redux";
import userdetails from "../store/reducers/userDetailsReducer"
import { admindetails } from "./actions/actionType";

let rootreducer=combineReducers({
    userdetailreducer:userdetails,
    admindetailsreducer:admindetails
});

let store=createStore(rootreducer);

export default store;